import React, { useState } from "react";
import { APIEndpoints } from "../Constants/APIEndpoints";
import BaseClient from "../../src/Helpers/BaseClient";
import CustomErrors from "../Constants/Errors";

const useAdmins = () => {
  const [admins, setAdmins] = useState([]);
  const [adminsLoading, setAdminsLoading] = useState(false);

  const fetchAdmins = async () => {
    try {
      setAdminsLoading(true);
      await BaseClient.get(APIEndpoints.getAllAdmins, {
        onSuccess: (response) => {
          setAdmins(response.data);
        },
        onFailed: (err) => {
          console.error("Error on fetching admin's list", err);
        },
      });
    } finally {
      setAdminsLoading(false);
    }
  };

  const updateAdminDetails = async (payload, { onSuccess, onFailed }) => {
    try {
      setAdminsLoading(true);
      await BaseClient.put(APIEndpoints.updateAdmins, payload, {
        onSuccess: onSuccess,
        onFailed: onFailed,
      });
    } finally {
      setAdminsLoading(false);
    }
  };

  const deleteAdmin = async (adminId, { onSuccess, onFailed }) => {
    try {
      setAdminsLoading(true);
      await BaseClient.deleteSub(APIEndpoints.deleteSingleAdmin, adminId, {
        onSuccess: onSuccess,
        onFailed: onFailed,
      });
    } finally {
      setAdminsLoading(false);
    }
  };

  const addNewAdmin = async (payload, { onSuccess, onFailed }) => {
    try {
      setAdminsLoading(true);

      await BaseClient.post(APIEndpoints.addAdmin, payload, {
        onSuccess: onSuccess,
        onFailed: onFailed,
      });
    } finally {
      setAdminsLoading(false);
    }
  };

  const fetchSingle = async (id, { onSuccess, onFailed }) => {
    try {
      setAdminsLoading(true);

      await BaseClient.post(
        APIEndpoints.fetchSingle + `/${id}`,
        {},
        {
          onSuccess: onSuccess,
          onFailed: onFailed,
        }
      );
    } finally {
      setAdminsLoading(false);
    }
  };

  return {
    admins,
    fetchAdmins,
    adminsLoading,
    updateAdminDetails,
    deleteAdmin,
    addNewAdmin,
    fetchSingle,
  };
};

export default useAdmins;
